import { CONTACT_FORM_URL } from './constants.js';

const faqText = document.getElementById('faq-text');
const contactButton = document.getElementById('contact-button');

faqText.setAttribute('src', `${process.env.CONTENT_ROOT}/pages/faq.html`);
contactButton.onclick = function () {
    const left = (screen.width - 570) / 2;
    const top = (screen.height - window.outerHeight) / 2;
    const params = `menubar=no,toolbar=no,status=no,width=570,height=${window.outerHeight},top=${top},left=${left}`;
    window.open(CONTACT_FORM_URL, 'NewWindow', params);
};
